var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 51,
    viewBox: "0 0 70 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5263 0H3.68421C1.65789 0 0 1.6396 0 3.64355C0 5.64751 1.65789 7.28711 3.68421 7.28711H40.5263C42.5526 7.28711 44.2105 5.64751 44.2105 3.64355C44.2105 1.6396 42.5526 0 40.5263 0ZM40.5263 14.5742H3.68421C1.65789 14.5742 0 16.2138 0 18.2178C0 20.2217 1.65789 21.8613 3.68421 21.8613H40.5263C42.5526 21.8613 44.2105 20.2217 44.2105 18.2178C44.2105 16.2138 42.5526 14.5742 40.5263 14.5742ZM3.68421 36.4355H25.7895C27.8158 36.4355 29.4737 34.7959 29.4737 32.792C29.4737 30.788 27.8158 29.1484 25.7895 29.1484H3.68421C1.65789 29.1484 0 30.788 0 32.792C0 34.7959 1.65789 36.4355 3.68421 36.4355ZM58.9474 0C54.8947 0 51.5789 3.2792 51.5789 7.28711V29.8043C50.4368 29.4035 49.1842 29.1484 47.8947 29.1484C41.1158 29.1484 35.8105 35.1239 37.0263 42.0466C37.8 46.4553 41.4474 50.0624 45.9053 50.8276C52.9053 52.03 58.9474 46.7832 58.9474 40.0791V7.28711H66.3158C68.3421 7.28711 70 5.64751 70 3.64355C70 1.6396 68.3421 0 66.3158 0H58.9474Z",
    fill: "#F22E62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink3);
export default __webpack_public_path__ + "static/media/link3.9c91a5f7fa576207a0d440041947d231.svg";
export { ForwardRef as ReactComponent };